import { render, staticRenderFns } from "./CarrierClassificationView.vue?vue&type=template&id=8c856482&"
import script from "./CarrierClassificationView.vue?vue&type=script&lang=js&"
export * from "./CarrierClassificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports